import React from 'react';
import { useProperty } from '../../hooks/useProperty';
import { useNavigate } from 'react-router-dom';
import { FORMS } from '../../schemas/stepMap';
import { Helmet } from 'react-helmet';
import FormBuilder from '../../components/formBuilder';
import PropertyPageHeader from '../../components/PropertyPageHeader';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../firebase/clientApp';
import { useUser } from '../../hooks/useUser';

const RehabWorksheet = () => {
  const { propertyData, scenarios } = useProperty();
  const { user } = useUser();

  const navigate = useNavigate();
  if (propertyData?.projectType === 'flip') {
    navigate('../flip-worksheet');
  }

  const scenario = scenarios.find((scenario) => scenario.isDefault !== true);

  const RehabWorksheetSchema = FORMS.rehabWorksheet.schema;

  const userScenarioId = scenario ? scenario.id : null;

  // get field that has defaultFrom
  const defaultFromFields = RehabWorksheetSchema.inputs.schema
    .flatMap((section) => section.schema)
    .filter((field) => field.defaultFrom);

  const defaults = Object.fromEntries(
    defaultFromFields.map((field) => [
      field.name,
      propertyData[field.defaultFrom],
    ])
  );

  function logCompleted() {
    logEvent(analytics, 'rehab_analysis_worksheet_completed', {
      user_id: user?.uid,
      property_id: propertyData?.propertyId,
    });
  }

  const data = {
    ...defaults,
    ...scenario,
  };

  return (
    <>
      <Helmet>
        <title>PropertyCast.io - BRRRR Worksheet</title>
      </Helmet>
      <section id="BRRRRWorksheet">
        <PropertyPageHeader
          title={RehabWorksheetSchema.inputs.title}
          description={RehabWorksheetSchema.inputs.description}
        />

        <FormBuilder
          formSchema={RehabWorksheetSchema}
          formType={FORMS.rehabWorksheet.formType}
          beforeData={propertyData}
          data={data}
          docId={userScenarioId}
          onFormSubmitted={logCompleted}
        />
      </section>
    </>
  );
};

export default RehabWorksheet;
